import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { FormControl, Validators } from '@angular/forms';
import { UploadedDocumentsStorage } from '../../storages/uploaded-documents-storage';
import { FileToLanguage } from '../../../../covance-file-upload/covance-file-upload.component';
import { UPLOAD_DLG_DATA_TOKEN, UploadDialogData } from '../base/upload-dialog-data';
import { UpdateDocumentDialogBase } from '../base/update-document-dialog-base';
import { CustomMethodUploadOptions } from '../base/method-upload-options';
import { FileFormArray } from '../../../../covance-file-upload/file-form-array';
import { GeneralReport, FileLink, Report, Category } from '../../../../documents';
import { FileExtensions } from '../file-extensions';
import { ELearningUploadStorage } from '../../storages/e-learning-upload-storage';
import { Observable } from 'rxjs';
import { HttpEvent } from '@angular/common/http';

@Component({
    selector: 'file-edit',
    template: require('./file-edit.component.html'),
    styles: [require('./file-edit.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileEditComponent extends UpdateDocumentDialogBase {
    public readonly languages: FileLink[] = [];
    public readonly subcategory: string;
    public readonly allowedFileExtensions: string[];
    public readonly isSingleUpload: boolean;
    public readonly report: Report;
    public readonly fileFormArray: FileFormArray;
    public readonly auditTrailReasonControl: FormControl;
    public selectedFiles: FileToLanguage;

    constructor(
        dialog: MdlDialogReference,
        dialogService: MdlDialogService,
        private readonly uploadedDocumentsStorage: UploadedDocumentsStorage,
        private readonly eLearningUploadStorage: ELearningUploadStorage,
        @Inject(UPLOAD_DLG_DATA_TOKEN) readonly dialogData: UploadDialogData<GeneralReport>,
        readonly fileExtensions: FileExtensions,
    ) {
        super(
            uploadedDocumentsStorage,
            dialog,
            dialogService,
            dialogData.report.category.categoryId);

        this.subcategory = dialogData.report.subcategoryTitle;
        this.report = dialogData.report;
        this.languages = dialogData.report.fileLinks;
        this.auditTrailReasonControl = new FormControl('', [Validators.required]);
        this.fileFormArray = new FileFormArray();

        this.editorForm.addControl('files', this.fileFormArray);
        this.editorForm.addControl('auditTrailReason', this.auditTrailReasonControl);

        this.allowedFileExtensions = fileExtensions.getAllowedFileExtensions(dialogData.report);
        this.isSingleUpload = dialogData.category.isSiteActions();
    }

    public onFilesChanged(selectedFiles: FileToLanguage) {
        this.selectedFiles = selectedFiles;
    }

    public async add() {
        const title = this.dialogData.report.title ? ` ${this.dialogData.report.title}` : '';
        const message = `You are going to replace a document${title}. Proceed?`;

        const confirmed = await this.showConfirm(message);
        
        if (confirmed) {
            let customUploadMethod: () => Observable<HttpEvent<Object>>;
            if (Category.isELearningCategory(this.dialogData.report.fileLinkCategory)) {
                customUploadMethod = () => this.eLearningUploadStorage.update(
                    this.dialogData.report.fileLinkCategory,
                    this.selectedFiles,
                    this.dialogData.report.reportId,
                    this.auditTrailReasonControl.value);
            } else {
                customUploadMethod = () => this.uploadedDocumentsStorage.update(
                    this.dialogData.report.fileLinkCategory,
                    this.selectedFiles,
                    this.dialogData.report.reportId,
                    this.auditTrailReasonControl.value);
            }

            this.upload(new CustomMethodUploadOptions(customUploadMethod, () => this.uploadedDocumentsStorage.forceLoadDocuments()));
        }
    }
}
